export const STORE_TYPES = [
  { v: "arab_supermarket", ar: "سوبرماركت عربي", en: "Arab Supermarket" },
  { v: "halal_market", ar: "سوق حلال", en: "Halal Market" },
  { v: "butcher", ar: "ملحمة", en: "Butcher" },
  { v: "bakery", ar: "مخبز", en: "Bakery" },
  { v: "sweet_shop", ar: "حلويات", en: "Sweet Shop" },
  { v: "grocery", ar: "بقالة", en: "Grocery" }
];

export const PRODUCT_CATEGORIES = [
  { v: "halal_meat", ar: "لحوم حلال", en: "Halal Meat" },
  { v: "chicken", ar: "دجاج", en: "Chicken" },
  { v: "fish", ar: "أسماك", en: "Fish" },
  { v: "vegetables", ar: "خضروات", en: "Vegetables" },
  { v: "fruits", ar: "فواكه", en: "Fruits" },
  { v: "dairy", ar: "ألبان", en: "Dairy" },
  { v: "arabic_bread", ar: "خبز عربي", en: "Arabic Bread" },
  { v: "rice", ar: "أرز", en: "Rice" },
  { v: "spices", ar: "بهارات", en: "Spices" },
  { v: "frozen_food", ar: "أطعمة مجمدة", en: "Frozen Food" },
  { v: "desserts", ar: "حلويات", en: "Desserts" },
  { v: "coffee_tea", ar: "قهوة وشاي", en: "Coffee & Tea" },
  { v: "ramadan", ar: "منتجات رمضان", en: "Ramadan" },
  { v: "middle_eastern", ar: "منتجات شرق أوسطية", en: "Middle Eastern" }
];

export const UNITS = [
  { v: "kg", ar: "كجم", en: "kg" },
  { v: "lb", ar: "رطل", en: "lb" },
  { v: "piece", ar: "قطعة", en: "piece" },
  { v: "bag", ar: "كيس", en: "bag" },
  { v: "bunch", ar: "حزمة", en: "bunch" },
  { v: "dozen", ar: "دزينة", en: "dozen" },
  { v: "g", ar: "جرام", en: "g" }
];

export const ORDER_STATUSES = [
  { v: "received", ar: "تم الاستلام", en: "Order Received", color: "bg-yellow-500/20 text-yellow-400" },
  { v: "shopping_in_progress", ar: "جاري التسوّق", en: "Shopping In Progress", color: "bg-blue-500/20 text-blue-400" },
  { v: "receipt_uploaded", ar: "تم رفع الفاتورة", en: "Receipt Uploaded", color: "bg-purple-500/20 text-purple-400" },
  { v: "out_for_delivery", ar: "في الطريق للتوصيل", en: "Out For Delivery", color: "bg-orange-500/20 text-orange-400" },
  { v: "delivered", ar: "تم التوصيل", en: "Delivered", color: "bg-emerald-500/20 text-emerald-400" },
  { v: "cancelled", ar: "ملغي", en: "Cancelled", color: "bg-red-500/20 text-red-400" }
];

export const lookup = (list, value, lang) => {
  const m = list.find((x) => x.v === value);
  return m ? (lang === "ar" ? m.ar : m.en) : value;
};
